import Flux from '../../flux/Flux';

/**
 * @return {{seconds: number, hour: number, minutes: number}}
 */
const getInitialTimer = function() {
	return {
		hour:    0,
		minutes: 0,
		seconds: 0,
	};
};

/**
 * @return {{seconds: *, hour: *, minutes: *}}
 */
const getTimer = function() {
	const {
		      DAY_DATE_HOURS,
		      DAY_DATE_MINUTES,
		      DAY_DATE_SECONDS,
	      } = Flux.Constants.DailyBonuses.timerConsts;

	const DATE_NOW = new Date();
	const locale   = 'en-US';
	let BERLIN     = DATE_NOW;
	if (Flux.Browser.isIE()) {
		BERLIN = new Date(DATE_NOW.toGMTString(locale, {timeZone: 'Europe/Berlin'}));
	} else if (typeof Date.toLocaleString === 'function') { // most browsers
		BERLIN = new Date(DATE_NOW.toLocaleString(locale, {timeZone: 'Europe/Berlin'}).replace(/\./g, '/'));
	} else if (typeof Date.toGMTString === 'function') { // IE
		BERLIN = new Date(DATE_NOW.toGMTString(locale, {timeZone: 'Europe/Berlin'}));
	} else { // fallback (old iOS safari)
		BERLIN = new Date(DATE_NOW.toString()); // ('en-US', {timeZone: 'Europe/Berlin'}));
	}

	const HOUR    = DAY_DATE_HOURS - BERLIN.getHours();
	const MINUTES = DAY_DATE_MINUTES - BERLIN.getMinutes();
	const SECONDS = DAY_DATE_SECONDS - BERLIN.getSeconds();
	// trigger reload
	if (HOUR === 0 && MINUTES === 0 && SECONDS === 0) {
		Flux.DailyBonus.triggerLoad();
	}
	return {
		hour:     HOUR < 10 ? '0' + HOUR : HOUR,
		minutes:  MINUTES < 10 ? '0' + MINUTES : MINUTES,
		seconds:  SECONDS < 10 ? '0' + SECONDS : SECONDS,
		fullTime: BERLIN,
	};
};

export {getInitialTimer, getTimer};
